import { withCustomRefine } from '@src/utils/validation/withCustomRefine';
import moment from 'moment';
import { z } from 'zod';

export const BOOK_NOW_SCHEMA = withCustomRefine(
    z.object({
        date: z.any().refine(val => moment.isMoment(val) && val.isValid(), {
            message: 'Fields cannot be empty for instant booking.'
        }),
        time: z.any().refine(val => !!val, { message: 'Fields cannot be empty for instant booking' }),
        quantity: z
            .number({
                required_error: 'Fields cannot be empty for instant booking'
            })
            .min(1, 'Fields cannot be empty for instant booking'),
        addOns: z.any().optional()
    }),
    (input, ctx) => {
        const { date } = input;

        const isDateValid = moment.isMoment(date) && date.isValid();

        if (isDateValid) {
            // check if date is the current date is after 30 days
            if (
                date.isAfter(
                    moment()
                        .add(30, 'days')
                        .endOf('day')
                )
            ) {
                ctx.addIssue({
                    path: ['date'],
                    code: z.ZodIssueCode.custom,
                    message:
                        'Please select a date within the next 30 days. Dates beyond this range are not available for booking'
                });
            }
        }
        return input;
    }
);
